<template>
  <b-col cols="12" class="steps">
    <b-row align-h="center" align-v="center" class="flex-nowrap">
      <b-col cols="auto" v-for="(item, index) in steps" :key="index" class="connector">
        <b-avatar
          :text="String(index + 1)"
          :variant="getStyles(item).variant"
          :icon="getStyles(item).icon"
          class="d-flex border border-2 mx-auto font-weight-bold text-md"
          :class="getStyles(item).iconText"
        ></b-avatar>
        <p
          class="mt-3 text-center text-md font-weight-bold avatar-text"
          :class="getStyles(item).text"
        >
          {{ item.text }}
        </p>
      </b-col>
    </b-row>
  </b-col>
</template>

<script setup lang="ts">
import { useRoute, type RouteRecordName } from 'vue-router'
import { useI18n } from 'vue-i18n'

// NAP-1113 - refactor this component:
// https://github.com/wiosna-dev/ap-swd/pull/880/files#r1735988224
// https://github.com/wiosna-dev/ap-swd/pull/880/files#r1735972486
// https://github.com/wiosna-dev/ap-swd/pull/880/files#r1735984873
// https://github.com/wiosna-dev/ap-swd/pull/880/files#r1735982346
// https://github.com/wiosna-dev/ap-swd/pull/880/files#r1735982456

type StepName = RouteRecordName | string
type Step = {
  name: StepName
  text: string
}

const { t } = useI18n()
const steps: Step[] = [
  {
    name: 'FormOfSupport',
    text: t('form.typeOfSupport.label')
  },
  {
    name: 'FormOfDonorData',
    text: 'Twoje Dane'
  },
  {
    name: 'Payment',
    text: 'Płatność'
  }
]

const route = useRoute()
const checkIsCurrentRoute = (routeName: StepName): boolean => {
  if (typeof routeName === 'undefined') {
    return false
  }
  return routeName === route.name || (Array.isArray(routeName) && routeName.includes(route.name))
}

const getStyles = (step: Step) => {
  const currentRouteIndex = steps.findIndex((value) => checkIsCurrentRoute(value.name))
  const currentIndex = steps.findIndex((value) => value.name === step.name)

  const isCurrentRoute = checkIsCurrentRoute(step.name)
  const isPreviousRoute = currentIndex < currentRouteIndex

  let variant = isCurrentRoute ? 'blue-50' : 'blue-50'
  variant = isPreviousRoute ? 'primary' : variant

  const icon = isPreviousRoute ? 'check' : ''

  const text = isCurrentRoute ? 'text-primary' : 'text-blue-300'

  let iconText = isCurrentRoute ? 'border-primary text-primary' : 'border-blue-gray'
  iconText = isPreviousRoute ? 'border-0 text-white' : iconText

  return {
    variant,
    icon,
    text,
    iconText
  }
}
</script>
